module.exports = __webpack_public_path__ + "/images/mockup_lista_ES.9522d2b.png";